"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildingGovIcon16Light = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.BuildingGovIcon16Light = forwardRef_1.forwardRef('BuildingGovIcon16Light', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 16 }, props),
        react_1.default.createElement("path", { d: "M6.455 2.35a2.5 2.5 0 0 1 3.09 0l5.146 4.043a.5.5 0 0 0 .618-.786l-5.147-4.044a3.5 3.5 0 0 0-4.324 0L.69 5.607a.5.5 0 0 0 .618.786L6.455 2.35Z" }),
        react_1.default.createElement("path", { d: "M4 7a.5.5 0 0 0-1 0v5.25a.5.5 0 0 0 1 0V7Z" }),
        react_1.default.createElement("path", { d: "M1.5 14a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1h-13Z" }),
        react_1.default.createElement("path", { d: "M6.5 6.5A.5.5 0 0 1 7 7v5.25a.5.5 0 0 1-1 0V7a.5.5 0 0 1 .5-.5Z" }),
        react_1.default.createElement("path", { d: "M10 7a.5.5 0 0 0-1 0v5.25a.5.5 0 0 0 1 0V7Z" }),
        react_1.default.createElement("path", { d: "M12.5 6.5a.5.5 0 0 1 .5.5v5.25a.5.5 0 0 1-1 0V7a.5.5 0 0 1 .5-.5Z" })));
});
